module.exports = __webpack_public_path__ + "static/media/business_disabled.003fbe0d.svg";